import React, { useState, useEffect, forwardRef, useImperativeHandle, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Table from "../../../../Components/UiComponents/Table/Table";
import {
  Editicon,
  Deleteicon,
  Claim,
  Complete,
  XCircleblack,
} from "../../../../Components/IconComponents";
import "./MyIndividualTaskList.css";
import { facilityTableData } from "../../../../JsonData/CreateFacilityConfig";
import TaskModalWithComment from "../../../../Components/UiComponents/TaskModalWithComment/TaskModalWithComment";
import {
  getData,
  postDataWithBody,
  postDataWithBodyFrGIS,
  putDataWithBody,
} from "../../../../Services/Services";
import {
  getMyTaskListURL,
  getMyIndividualTaskListURL,
  completeNotificationtask,
  getAllIndlTask,
  completeNotificationTypeTask,
  completeIndiTask,
  completeIndivTask,
} from "../../../../Services/EndPoints";
import Moment from "react-moment";
import { toast, ToastContainer } from "react-toastify";
import Confirmpopup from "../../Common/ConfirmPopup/Confirmpopup";
import { useKeycloak } from "@react-keycloak/web";
import StatusHandler from "../../Common/StatusHandler/StatusHandler";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import { ThemeContext } from "../../../..";

const MyIndividualTaskList = forwardRef((props, ref) => {
  const [data, setData] = useState([]);
  const { t } = useTranslation();
  const [selectedSopInstanceId, setSelectedSopInstanceId] = useState(null);
  const [taskData, setTaskData] = useState(null);
  const [showPop, setShowPop] = React.useState(false);
  const [rowCount, setRowCount] = useState(0);
  const navigate = useNavigate();
  const { theme } = useContext(ThemeContext);

  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    if (keycloak.authenticated) {
      getMyTaskList();
    }
  }, [keycloak.authenticated]);

  let taskServiceData = [];
  const getMyTaskList = async () => {
    var myTaskList = await postDataWithBody(
      getAllIndlTask,
      { email: getLoggedInuserName() },
      {}
    );
    myTaskList = myTaskList;
    taskServiceData = myTaskList;
    setRowCount(myTaskList.length);
    setData(myTaskList);
  };

  // Expose the refresh function to parent component
  useImperativeHandle(ref, () => ({
    refreshTaskList: () => {
      getMyTaskList();
    }
  }));

  const getLoggedInuserName = () => {
    return keycloak.idTokenParsed.email;
  };

  const addNewHandler = () => {
    navigate("/planning/facility-mgmt/create-facility");
  };

  const showCompleteTaskPopup = (elem) => {
    setTaskData(elem);
    setShowPop(!showPop);
  };

  function refreshTaskTable() {
    getMyTaskList();
    setShowPop(false);
  }

  const columns = React.useMemo(
    () => [
      {
        Header: t("dailyoperationaltasktableheaders.taskname"),
        accessor: "name",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            let descriptionText = props.value;
            return <span title={props.value}>{descriptionText}</span>;
          } else {
            return "NA";
          }
        },
      },
      {
        Header: t("dailyoperationaltasktableheaders.description"),
        accessor: "description",
        disableSortBy: true,
        Cell: (props) => {
          const [showModal, setShowModal] = useState(false);
          const [fullDescription, setFullDescription] = useState("");
          const [highlightedDescription, setHighlightedDescription] =
            useState("");

          const handleShowModal = (description) => {
            setFullDescription(description);
            setHighlightedDescription(description);
            setShowModal(true);
          };

          const handleCloseModal = () => {
            setShowModal(false);
            setHighlightedDescription("");
          };

          const descriptionText = props.value || "NA";
          const truncatedDescription =
            descriptionText.length > 25
              ? `${descriptionText.substring(0, 25)}...`
              : descriptionText;

          const isHighlighted = descriptionText === highlightedDescription;
          if (showModal) {
            setTimeout(() => {
              let el = document.querySelector(".modal-content");
              el.style.cssText =
                "background-color: #1c2038 !important; border-radius: 20px !important;";
            }, 0);
          }

          return (
            <span>
              <span
                title={descriptionText}
                style={{
                  cursor: "pointer",
                  backgroundColor: isHighlighted ? "#18A3A0" : "transparent",
                  padding: "2px 5px",
                  borderRadius: "5px",
                }}
                onClick={() => handleShowModal(descriptionText)}
              >
                {truncatedDescription}
              </span>

              <Modal
                show={showModal}
                onHide={handleCloseModal}
                dialogClassName="custom-modal"
                centered
                style={{
                  borderRadius: "20px",
                  border: "none",
                  top: "20%",
                }}
              >
                <Modal.Header
                  style={{
                    backgroundColor: theme === "light" ? "#2b6591" : "#1c2038", // Dark blue background for header
                    color: "white", // White text in the header
                    borderBottom: "none", // Remove bottom border to prevent white edges
                  }}
                >
                  <Modal.Title style={{ color: "white" }}>
                    Full Description
                  </Modal.Title>
                  <XCircleblack
                    onClick={handleCloseModal}
                    width="1.5em"
                    height="1.5em"
                    className="cursor-pointer"
                  />
                </Modal.Header>
                <Modal.Body
                  style={{
                    backgroundColor: theme === "light" ? "#fcfcfc" : "#252b48", // Blue background for body
                    color: theme === "light" ? "#001b30" :"white", // White text in the body
                    border: "none", // Remove border to prevent white edges
                    borderRadius: "0px", // Remove radius to make it seamless
                    padding: "20px", // Added padding for spacing
                    lineHeight: "1.8",
                  }}
                >
                  <p>{fullDescription}</p>
                </Modal.Body>
                <Modal.Footer
                  style={{
                    backgroundColor: theme === "light" ? "#fcfcfc" : "#252b48", // Darker blue footer
                    color: "white", // White text in footer
                    borderTop: "none", // Remove top border to prevent white edges
                  }}
                >
                  <Button
                    variant="secondary"
                    onClick={handleCloseModal}
                    style={{
                      backgroundColor: theme === "light" ? "#2b6591" : "#252b48", // Dark blue button
                      borderColor: "#003366", // Dark border for button
                      borderRadius: "5px", // Rounded button edges
                    }}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </span>
          );
        },
      },
      {
        Header: t("dailyoperationaltasktableheaders.actionmessage"),
        accessor: "action_message",
        disableSortBy: true,
        Cell: (props) => {
          const [showModal, setShowModal] = useState(false);
          const [fullMessage, setFullMessage] = useState("");
          const [highlightedMessage, setHighlightedMessage] = useState("");
      
          const handleShowModal = (message) => {
            setFullMessage(message);
            setHighlightedMessage(message);
            setShowModal(true);
          };
      
          const handleCloseModal = () => {
            setShowModal(false);
            setHighlightedMessage("");
          };
      
          const messageText = props.value || "NA";
          const truncatedMessage =
            messageText.length > 25 ? `${messageText.substring(0, 25)}...` : messageText;
      
          const isHighlighted = messageText === highlightedMessage;
      
          if (showModal) {
            setTimeout(() => {
              let el = document.querySelector(".modal-content");
              el.style.cssText =
                "background-color: #1c2038 !important; border-radius: 20px !important;";
            }, 0);
          }
      
          return (
            <span>
              <span
                title={messageText}
                style={{
                  cursor: "pointer",
                  backgroundColor: isHighlighted ? "#18A3A0" : "transparent",
                  padding: "2px 5px",
                  borderRadius: "5px",
                }}
                onClick={() => handleShowModal(messageText)}
              >
                {truncatedMessage}
              </span>
      
              <Modal
                show={showModal}
                onHide={handleCloseModal}
                dialogClassName="custom-modal"
                centered
                style={{
                  borderRadius: "20px",
                  border: "none",
                  top: "20%",
                }}
              >
                <Modal.Header
                  style={{
                    backgroundColor: theme === "light" ? "#2b6591" : "#1c2038",
                    color: "white",
                    borderBottom: "none",
                  }}
                >
                  <Modal.Title style={{ color: "white" }}>Full Action Message</Modal.Title>
                  <XCircleblack
                    onClick={handleCloseModal}
                    width="1.5em"
                    height="1.5em"
                    className="cursor-pointer"
                  />
                </Modal.Header>
                <Modal.Body
                  style={{
                    backgroundColor: theme === "light" ? "#fcfcfc" : "#252b48", // Blue background for body
                    color: theme === "light" ? "#001b30" :"white", // White text in the body
                    border: "none",
                    padding: "20px",
                    lineHeight: "1.8",
                  }}
                >
                  <p>{fullMessage}</p>
                </Modal.Body>
                <Modal.Footer
                  style={{
                    backgroundColor: theme === "light" ? "#fcfcfc" : "#252b48",
                    color: "white",
                    borderTop: "none",
                  }}
                >
                  <Button
                    variant="secondary"
                    onClick={handleCloseModal}
                    style={{
                      backgroundColor: theme === "light" ? "#2b6591" : "#252b48",
                      borderColor: "#003366",
                      borderRadius: "5px",
                    }}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </span>
          );
        },
      },
      {
        Header: t("dailyoperationaltasktableheaders.createdby"),
        accessor: "created_by",
        disableSortBy: true,
      },
      {
        Header: t("dailyoperationaltasktableheaders.tasktype"),
        accessor: "task_type",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value == 1) {
            return "Notification";
          } else if (props.value == 0) {
            return "Activity";
          }
        },
      },
      {
        Header: t("dailyoperationaltasktableheaders.createdon"),
        accessor: "created_on",
        Cell: (props) => {
          if (props.value) {
            return <Moment format="DD/MM/YYYY, hh:mm a">{props.value}</Moment>;
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
      },
      {
        Header: t("dailyoperationaltasktableheaders.updatedon"),
        accessor: "updated_on",
        Cell: (props) => {
          if (props.value) {
            return <Moment format="DD/MM/YYYY, hh:mm a">{props.value}</Moment>;
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
      },
      {
        Header: t("dailyoperationaltasktableheaders.status"),
        accessor: "task_status_code",
        disableSortBy: true,
        Cell: (props) => {
          const originalStatus = props.row.original.task_status_code;
          const [showConfirmPopup, setShowConfirmPopup] = useState(false);
          const [showActivityConfirmPopup, setShowActivityConfirmPopup] = useState(false);
          
          const toggleConfirmPopup = () => {
            setShowConfirmPopup(!showConfirmPopup);
          };
          
          const toggleActivityConfirmPopup = () => {
            setShowActivityConfirmPopup(!showActivityConfirmPopup);
          };
          
          const handleStatusChange = (newStatus) => {
            const { id, task_type } = props.row.original;
            
            if (newStatus === "TASK_EXE_STATUS_INPROGRESS") {
              if (task_type === 0) {
                showCompleteTaskPopup(props.row.original);
              } else {
                toggleConfirmPopup();
              }
            } else if (newStatus === "TASK_EXE_STATUS_COMPLETED") {
              if (task_type === 1) {
                toggleConfirmPopup();
              } else {
                showCompleteTaskPopup(props.row.original);
              }
            }
          };
          
          const confirmTaskById = async (id) => {
            let input = {
              id: id,
              email: getLoggedInuserName(),
            };
            var res = await postDataWithBody(
              completeNotificationTypeTask,
              input,
              {}
            );
            if (res.status === "success") {
              getMyTaskList();
            }
            toast.success(res.msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
            toggleConfirmPopup();
          };
          
          const todayDate = new Date().toISOString().split("T")[0];
          
          const confirmTaskByIdActivity = async (id) => {
            let input = {
              id: id,
              taskCompletedDate: todayDate,
            };
            var res = await postDataWithBody(completeIndivTask, input, {});
            if (res.status === "success") {
              getMyTaskList();
            }
            toast.success(res.msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
            toggleActivityConfirmPopup();
          };
          
          const getDropdownColor = (status) => {
            switch (status) {
              case "TASK_EXE_STATUS_NEW_TASK":
                return "#e95060";
              case "TASK_EXE_STATUS_INPROGRESS":
                return "#ffaa22";
              case "TASK_EXE_STATUS_COMPLETED":
                return "#13845d";
              default:
                return "gray";
            }
          };
          
          if (originalStatus === "TASK_EXE_STATUS_INPROGRESS_SOMEONE") {
            return (
              <div className="startedbysomeone">
                <div>{t("Task started by someone")}</div>
              </div>
            );
          }
          
          if (originalStatus === "TASK_EXE_STATUS_COMPLETED") {
            return (
              <div style={{
                padding: "5px",
                border: "1px solid #ddd",
                borderRadius: "4px",
                backgroundColor: getDropdownColor(originalStatus),
                color: "white",
                width: "120px",
              }}>
                <div>{props.row.original.task_type === 1 ? t("Acknowledged") : t("Completed")}</div>
              </div>
            );
          }
          
          return (
            <div>
              <select
                value={originalStatus}
                onChange={(e) => handleStatusChange(e.target.value)}
                style={{
                  padding: "5px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  backgroundColor: getDropdownColor(originalStatus),
                  color: "white",
                  width: "120px",
                }}
              >
                <option
                  value="TASK_EXE_STATUS_NEW_TASK"
                  disabled={originalStatus !== "TASK_EXE_STATUS_NEW_TASK"}
                >
                  {props.row.original.task_type === 1 ? t("New Message") : t("New Task")}
                </option>
                
                {props.row.original.task_type !== 1 && (
                  <option
                    value="TASK_EXE_STATUS_INPROGRESS"
                    disabled={originalStatus === "TASK_EXE_STATUS_COMPLETED"}
                  >
                    {t("In Progress")}
                  </option>
                )}
                
                <option
                  value="TASK_EXE_STATUS_COMPLETED"
                  disabled={
                    props.row.original.task_type === 1
                      ? originalStatus !== "TASK_EXE_STATUS_NEW_TASK"
                      : originalStatus !== "TASK_EXE_STATUS_INPROGRESS"
                  }
                >
                  {props.row.original.task_type === 1 ? t("Acknowledged") : t("Completed")}
                </option>
              </select>
              
              {showConfirmPopup && (
                <Confirmpopup
                  className="DeltePopup"
                  show={showConfirmPopup}
                  title={t("acknowldgtask")}
                  message={t("popupmsg")}
                  handleToggle={toggleConfirmPopup}
                  row={props.row}
                  name={props.row.original.task_name}
                  deleteRow={() => confirmTaskById(props.row.original.id)}
                  cancel={t("cancelbutton")}
                  action={t("confirm")}
                />
              )}
              
              {showActivityConfirmPopup && (
                <Confirmpopup
                  className="DeltePopup"
                  show={showActivityConfirmPopup}
                  title={t("acknowldgtask")}
                  message={"Are you sure you want to complete the task?"}
                  handleToggle={toggleActivityConfirmPopup}
                  row={props.row}
                  name={props.row.original.task_name}
                  deleteRow={() => confirmTaskByIdActivity(props.row.original.id)}
                  cancel={t("cancelbutton")}
                  action={t("confirm")}
                />
              )}
            </div>
          );
        }
      }
    ],
    [t]
  );

  return (
    <div className="my-individual-task-table">
      <style>{`
        .my-individual-task-table tbody tr td,
        .my-individual-task-table tbody tr th {
          border: none !important;
        }
        .my-individual-task-table tbody tr td {
          background-color: #fff !important;
          color: #1D2939 !important;
        }
        .my-individual-task-table tbody tr:nth-child(even) td {
          background-color: #F9FAFB !important;
        }
      `}</style>
      {showPop && (
        <TaskModalWithComment
          titleValue={t("actiontaken")}
          showSuccessMsg={refreshTaskTable}
          taskData={taskData}
          show={showPop}
          buttonLabel={t("popup.save")}
          handleToggle={showCompleteTaskPopup}
          getMyTaskList={getMyTaskList}
          setShowPop={setShowPop}
          {...props}
        />
      )}

      {facilityTableData && (
        <Table
          data={data}
          title=""
          columns={columns}
          numberOfRows={7}
          showExport={false}
          showReset={false}
          onExpand={false}
          showSearch={true}
          isHeaderFixed={true}
          rowCount={rowCount}
          headerTableHeadStyle={{ background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)", color: "#FFFFFF" }}
          tableStyle={{
            border: "1px solid  #f0f0f0",
            padding: "2px",
            borderRadius: "12px",
          }}
        />
      )}
    </div>
  );
});

export default MyIndividualTaskList;